import { Split } from 'lucide-react';
import { CONTROL_FLOW_ICON_COLOR } from '../../styles';
import { NodeCategory, OutputType, type LBNodeInfo } from '../../types';
import { defaultNodeData } from '../../graphUtils';

export const PathsNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'paths',
  category: NodeCategory.CONTROL_FLOW,
  label: 'Paths',
  hasInput: true,
  getIcon: (size: number) => (
    <Split size={size} color={CONTROL_FLOW_ICON_COLOR} />
  ),
  outputType: OutputType.MULTIPLE,
  createDefaultNodeData: () => defaultNodeData('paths', {}),
};
